import { createSelector } from 'reselect';
import Constants from './constants';
import Enums from '../../../Constants/Enums';

const STATE_KEY_NAME = Constants.MODULE_NAME;

const stateSelector = (state) => state[STATE_KEY_NAME];

const signUpFieldsSelector = createSelector(stateSelector, (state) => state.fields);
const signUpLoadingSelector = createSelector(stateSelector, (state) => state.isLoading);
const signUpPrePopulatedFieldsSelector = createSelector(stateSelector, (state) => state.prepopulatedFields);
const signUpProductSelector = createSelector(stateSelector, (state) => {
  if (state.prepopulatedFields?.product === Enums.PRODUCT.SEARCH && state.prepopulatedFields?.isPurchaseLink) {
    return Enums.PRODUCT_TYPE.SEARCH_PURCHASE;
  }
  if (state.prepopulatedFields?.product === Enums.PRODUCT.SEARCH && !state.prepopulatedFields?.isPurchaseLink) {
    return Enums.PRODUCT_TYPE.SEARCH_TRIAL;
  }
  if (state.prepopulatedFields?.product === Enums.PRODUCT.API && state.prepopulatedFields?.isPurchaseLink) {
    return Enums.PRODUCT_TYPE.API_PURCHASE;
  }
  if (state.prepopulatedFields?.product === Enums.PRODUCT.API && !state.prepopulatedFields?.isPurchaseLink) {
    return Enums.PRODUCT_TYPE.API_TRIAL;
  }
  if (state.prepopulatedFields?.product === Enums.PRODUCT.VERIFY_API && state.prepopulatedFields?.isPurchaseLink) {
    return Enums.PRODUCT_TYPE.VERIFY_API_PURCHASE;
  }
  if (state.prepopulatedFields?.product === Enums.PRODUCT.VERIFY_API && !state.prepopulatedFields?.isPurchaseLink) {
    return Enums.PRODUCT_TYPE.VERIFY_API_TRIAL;
  }
  return Enums.PRODUCT_TYPE.SEARCH_TRIAL;
});

export const SignUpSelectors = {
  signUpFieldsSelector,
  signUpLoadingSelector,
  signUpPrePopulatedFieldsSelector,
  signUpProductSelector,
};
